import axios from "axios";
import authHeader from "@/services/auth-header";

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/v2`;
const main = "NWAPP";
const sub = "LoanPaymentInformation";

class LoanPaymentInformationService {
  downloadNachaFile(fileDataId, loanPaymentId) {
    return axios
      .get(`${API_URL}/${main}/${sub}/Download/Nacha/${fileDataId}/${loanPaymentId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }
}

export default new LoanPaymentInformationService();
